var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AnimeListBlock',{attrs:{"id":"favorite","animes":_vm.listFavorites(),"title":"我的動畫","row":"1000","openData":{}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }